export default __webpack_public_path__ + "static/media/s1_female.06101fda.wav";